import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Dropdown, FormLabel, Row } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import ListPage from '../../../layouts/page/ListPage';
import MenuConfig from '../../../../constants/MenuConfig';
import Api from '../../../../constants/Api';
import { Columns } from './Columns';
import axiosInstance from '../../../../services/AxiosInstance';
import { warnAlert } from '../../../components/alert/defaultAlert';
import Swal from 'sweetalert2';
import FilterAccordion from '../../../components/Common/Filter/FilterAccordion';
import InputText from '../../../components/Forms/Element/InputText';
import { SearchOperation } from '../../../../utils/ApiUtils';

const CompanyList = () => {
    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [nameFilter, setNameFilter] = useState('');
    const [corporateNameFilter, setCorporateNameFilter] = useState('');
    const [responsibleNameFilter, setResponsibleNameFilter] = useState('');
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const activeFilters = [];
        const addFilter = (field, value) => {
            if (value.trim()) {
                activeFilters.push({ field, value: value.trim(), operation: SearchOperation.MATCH });
            }
        };
        addFilter('name', nameFilter);
        addFilter('corporateName', corporateNameFilter);
        addFilter('responsibleName', responsibleNameFilter);
        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setCorporateNameFilter('');
        setResponsibleNameFilter('');
        setFilters([]);
    };

    const handleResendWelcomeEmail = async () => {
        if (!selectedRows || selectedRows.length === 0) {
            warnAlert(t('validation.required.row'));
            return;
        }
        if (selectedRows.length > 1) {
            warnAlert(t('validation.required.row_select_one'));
            return;
        }

        const companyId = selectedRows[0].id;
        
        try {
            const response = await axiosInstance.post(`/registration/companies/superadmin/${companyId}/resend-welcome-email`);
            const url = response.data.url;
            
            Swal.fire({
                title: 'Email Reenviado!',
                text: 'O e-mail de boas-vindas foi reenviado com sucesso. Você também pode copiar o link de acesso direto abaixo:',
                icon: 'success',
                input: 'text',
                inputValue: url,
                showCancelButton: true,
                confirmButtonText: 'Copiar Link',
                cancelButtonText: 'Fechar',
                customClass: {
                    input: 'form-control form-control-sm'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    navigator.clipboard.writeText(url);
                    Swal.fire('Copiado!', 'Link de acesso copiado para a área de transferência.', 'success');
                }
            });
        } catch (error) {
            warnAlert('Erro ao reenviar e-mail de boas-vindas.');
        }
    };

    const customButtons = [
        <Dropdown.Item key="resend-email" onClick={handleResendWelcomeEmail}>
            <i className="fas fa-envelope me-2"></i> Reenviar Acesso
        </Dropdown.Item>
    ];

    return (
        <>
            <PageTitle activeMenu={t('superadmin_company.menu')} motherMenu={t('administration')} />
            <FilterAccordion title="filters" onSearch={handleSearch} onClear={handleClearFilters} centerButtons={false}>
                <Row className="g-2 align-items-end">
                    <Col lg={4} md={6}>
                        <FormLabel>{t('trade_name')}</FormLabel>
                        <InputText value={nameFilter} onChange={(event) => setNameFilter(event.target.value)} placeholder={t('trade_name')} />
                    </Col>
                    <Col lg={4} md={6}>
                        <FormLabel>Razão social</FormLabel>
                        <InputText value={corporateNameFilter} onChange={(event) => setCorporateNameFilter(event.target.value)} placeholder="Razão social" />
                    </Col>
                    <Col lg={4} md={6}>
                        <FormLabel>Responsável</FormLabel>
                        <InputText value={responsibleNameFilter} onChange={(event) => setResponsibleNameFilter(event.target.value)} placeholder="Nome do responsável" />
                    </Col>
                </Row>
            </FilterAccordion>
            <ListPage
                showPageTitle={false}
                activeMenu={t('superadmin_company.menu')}
                motherMenu={t('administration')}
                path={Api.registration.company_superadmin}
                route={MenuConfig.superadmin.company.route}
                columns={Columns}
                setSelectedRows={setSelectedRows}
                customButtons={customButtons}
                filters={filters}
            />
        </>
    );
};

export default CompanyList;
